import { AxiosRequestConfig } from 'axios'

import { useMutator as useOrvalMutator } from '@dhl/receiver-axios'
import { apiConfig } from './client/config'

export const useMutator = <T>(): ((config: AxiosRequestConfig) => Promise<T>) => {
  const { baseUrl } = apiConfig

  return useOrvalMutator(baseUrl)
}
